import * as React from 'react';
import {connect} from 'react-redux';
import history from '../../config/history';
import {actions} from '../../reducers/boCore';
import {setTitle} from '../../actions/topHeaderActions';
import {fetchAllBusinessObjects, fetchAllDataViewsByBusinessObjectId, fetchAllTags} from '../../actions/boCoreActions';
import {BusinessObjectWrapperInterface} from "../../components/bo-core/Interfaces/BusinessObjectWrapperInterface";
import {DataViewWrapperInterface} from "../../components/bo-core/Interfaces/DataViewWrapperInterface";
import ManageDataGrid from "../../components/bo-core/grids/ManageDataGrid/ManageDataGrid";
import {RouteComponentProps, withRouter} from "react-router";
import Utils from "../../Utils";
import Select from 'react-select';
import {DataTypesEnum} from "../../components/bo-core/enums/dataTypesEnum";
import {BusinessObjectInterface} from "../../components/bo-core/Interfaces/BusinessObjectInterface";
import {DataViewInterface} from "../../components/bo-core/Interfaces/DataViewInterface";
import {setBusinessObject} from "../../actions/manageDataBusinessObjectActions";
import SavedSearchFields from "../../components/common/SavedSearchFields";
import {setSelectedSearch} from "../../actions/savedSearchActions";
import _ from "lodash";
import Axios from "../../config/Axios";
import * as toastr from "toastr";

interface Props extends RouteComponentProps {
    dataViewsWrapper: DataViewWrapperInterface;
    businessObjectsWrapper: BusinessObjectWrapperInterface;
    title: any;
    businessObject: any;
    selectedSearch: any;
    lastSearch: any;

    fetchAllTags(): void;

    setTitle(title: string): void;

    setBusinessObject(obj: any): void;

    fetchAllBusinessObjects(): void;

    fetchAllDataViewsByBOCId(id: number): void;

    setSelectedSearch(obj: any): void;
}

interface State {
    currentDataView: any;
    currentBusinessObject: any;
}

const hash = require('object-hash');
const queryString = require('query-string');

class ManageData extends React.Component<Props, State> {
    private waitingSearch: any = null;

    constructor(props) {
        super(props);
        this.state = {
            currentDataView: null,
            currentBusinessObject: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.props.fetchAllTags();
        this.props.fetchAllBusinessObjects();
    };

    UNSAFE_componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
        const {businessObjectsWrapper, dataViewsWrapper} = this.props;
        const nextQuery = queryString.parse(nextProps.location.search);
        const prevQuery = queryString.parse(this.props.location.search);

        if (this.props.businessObject === null || nextQuery.boc === Utils.SysRuleEngineRules || nextQuery.boc === Utils.SysRuleEngineActions) {
            if (nextProps.businessObjectsWrapper && (businessObjectsWrapper !== nextProps.businessObjectsWrapper) || (hash(nextQuery) !== hash(prevQuery))) {
                if (nextProps.businessObjectsWrapper.hasBusinessObject(nextQuery.boc)) {
                    const businessObject = nextProps.businessObjectsWrapper.getBusinessObject(nextQuery.boc);
                    this.setState({
                        currentBusinessObject: {
                            id: businessObject.id,
                            name: businessObject.name,
                            description: businessObject.description,
                            inferenceTemp: businessObject.inferenceTemp
                        }
                    });
                    this.props.fetchAllDataViewsByBOCId(businessObject.id);
                } else {
                    const businessObjects = (nextProps.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY) as BusinessObjectInterface[]
                    ).sort((a, b) => a.name.localeCompare(b.name));
                    const businessObject = businessObjects[0];
                    if (businessObject) {
                        this.setState({
                            currentBusinessObject: {
                                id: businessObject.id,
                                name: businessObject.name,
                                description: businessObject.description,
                                inferenceTemp: businessObject.inferenceTemp
                            }
                        });
                    }
                    this.props.fetchAllDataViewsByBOCId(businessObject.id);
                }
            }
        } else {
            if (nextProps.businessObjectsWrapper && (businessObjectsWrapper !== nextProps.businessObjectsWrapper) || (hash(nextQuery) !== hash(prevQuery))) {
                if (nextProps.businessObjectsWrapper.hasBusinessObject(this.props.businessObject.name)) {
                    const businessObject = nextProps.businessObjectsWrapper.getBusinessObject(this.props.businessObject.name);
                    this.setState({
                        currentBusinessObject: {
                            id: businessObject.id,
                            name: businessObject.name,
                            description: '',
                            inferenceTemp: businessObject.inferenceTemp
                        }
                    });
                    this.props.fetchAllDataViewsByBOCId(businessObject.id);
                }
            }
        }
        if (nextProps.dataViewsWrapper && !_.isEqual(dataViewsWrapper, nextProps.dataViewsWrapper) && !this.waitingSearch) {
            const currentMapOfViewsIds = dataViewsWrapper ? (dataViewsWrapper.getDataViews(DataTypesEnum.ARRAY) as DataViewInterface[]).map(item => {
                return item.id
            }) : null;
            const nextMapOfViewsIds = (nextProps.dataViewsWrapper.getDataViews(DataTypesEnum.ARRAY) as DataViewInterface[]).map(item => {
                return item.id
            });
            const areArraysEqual = (x, y) => {
                return _(x).differenceWith(y, _.isEqual).isEmpty();
            };
            if (!currentMapOfViewsIds || !areArraysEqual(currentMapOfViewsIds, nextMapOfViewsIds)) {
                this.setState({
                    currentDataView: nextProps.dataViewsWrapper.getDefaultDataViewByBocId(this.state.currentBusinessObject.id)
                });
            }
        }
    };

    componentDidMount() {
        this.props.setTitle("Manage Data");
    };

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.props.dataViewsWrapper && prevProps.dataViewsWrapper !== this.props.dataViewsWrapper && this.waitingSearch) {
            this.onDataViewChange({value: this.waitingSearch.data.dataViewId}, this.waitingSearch);
        }
    }

    componentWillUnmount() {
        this.props.setTitle("");
    };

    onBusinessObjectChange = (item: any, search?: any) => {
        const currBusinessObj = {
            id: item.value,
            name: item.label
        }
        this.props.setBusinessObject(currBusinessObj);
        this.setState({
            currentBusinessObject: currBusinessObj
        }, () => {
            Utils.$("#export-btn").attr("disabled", true);
            Utils.$("#import-btn").attr("disabled", true);
            history.replace({
                pathname: `${process.env.ENV_PREFIX}/managedata`,
                search: `?boc=${currBusinessObj.name}`
            });

            if (search) {
                this.waitingSearch = search;
            } else if (this.props.selectedSearch !== null) {
                this.props.setSelectedSearch(null);
            }
            this.props.fetchAllDataViewsByBOCId(currBusinessObj.id);
        });
    };

    getCurrentSavedSearch = (id: number) => {
        Axios.instanceV2.get(`search/${id}`)
            .then(response => {
                this.props.setSelectedSearch({
                    label: response.data.name,
                    value: response.data.id,
                    data: response.data
                });
            })
            .catch(error => {
                toastr.error(error.response.data.message)
            })
    };

    onDataViewChange = (item: any, search?: any) => {
        if (this.props.selectedSearch !== null) {
            this.props.setSelectedSearch(null);
        }
        this.setState({
            currentDataView: this.props.dataViewsWrapper.getDataView(item.value)
        }, () => {
            if (search) {
                // This timeout guarantees that the selected saved search will be stored in redux, once the business object and data view are already set.
                // That is essential for the equality check which is performed inside serverSideDatasource method of the Manage Data Grid
                setTimeout(() => {
                    this.getCurrentSavedSearch(search.data.id)
                }, 0)
            } else if (this.props.selectedSearch !== null) {
                this.props.setSelectedSearch(null);
            }
            this.waitingSearch = null;
        });
    };

    setDataViewToFocus = (e) => {
        if (e.keyCode === 9) {
            e.preventDefault();
            $(this.refs.dataView).focus();
        }
        if (e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
    };

    setSavedSearchToFocus = (e) => {
        if (e.keyCode === 9) {
            // Its very important not to use event.preventDefault()!
            document.getElementById("savedSearchSelect").focus();
        }
        if (e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
    };

    handleSelectedSearch = (searchObj: any) => {
        const {currentBusinessObject, currentDataView} = this.state;
        const {typeId, dataViewId} = searchObj.data;
        if (currentBusinessObject.id === typeId && currentDataView.id === dataViewId) {
            this.getCurrentSavedSearch(searchObj.data.id);
        } else if (currentBusinessObject.id === typeId && currentDataView.id !== dataViewId) {
            const dataViewItem = {
                value: dataViewId
            };
            this.onDataViewChange(dataViewItem, searchObj);
        } else if (currentBusinessObject.id !== typeId) {
            const foundType = (this.props.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY) as BusinessObjectInterface[]).map(item => {
                return {
                    value: item.id,
                    label: item.name
                }
            }).find(el => {
                return el.value === typeId;
            });
            if (foundType) {
                this.onBusinessObjectChange(foundType, searchObj);
            }
        }
    };

    render() {
        if (this.props.businessObjectsWrapper === null || this.props.dataViewsWrapper === null || this.state.currentBusinessObject === null || this.state.currentDataView === null) {
            return null
        }

        return (
            <div style={{height: "100%", width: "100%"}} className="bo-core">
                <div style={{height: 50, marginRight: 0, marginLeft: 0, display: "flex", alignItems: "center"}}
                     className="row bo-core-header top-header">
                    <span className="header-title">{this.props.title}</span>
                    <div style={{width: 200}}>
                        <Select
                            styles={Utils.getReactSelectNewDesign()}
                            onKeyDown={this.setDataViewToFocus}
                            id={'getBusinessObjects'}
                            autoFocus={true}
                            value={{
                                value: this.state.currentBusinessObject.id,
                                label: `Type: ` + this.state.currentBusinessObject.name
                            }}
                            options={(this.props.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY) as BusinessObjectInterface[]).map(item => {
                                return {
                                    value: item.id,
                                    label: item.name
                                }
                            }).sort((a, b) => a.label.localeCompare(b.label))}
                            onChange={(item) => this.onBusinessObjectChange(item, null)}
                            tabIndex={1}
                            theme ={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#5f8c90',
                                    primary: '#34585b',
                                    primary50: '#5f8c90'
                                },
                            })}
                        />
                    </div>
                    <div style={{width: 200, marginLeft: "auto", marginRight: 5}}>
                        <Select
                            styles={Utils.getReactSelectNewDesign()}
                            ref={"dataView"}
                            onKeyDown={this.setSavedSearchToFocus}
                            value={{
                                value: this.state.currentDataView.id,
                                label: 'Data View: ' + this.state.currentDataView.viewName
                            }}
                            options={(this.props.dataViewsWrapper.getDataViews(DataTypesEnum.ARRAY) as DataViewInterface[]).filter(item => {
                                return item.isActive === true
                            }).map(item => {
                                return {
                                    value: item.id,
                                    label: item.viewName
                                }
                            }).sort((a, b) => a.label.localeCompare(b.label))}
                            onChange={(item) => this.onDataViewChange(item, null)}
                            tabIndex={2}
                            theme ={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#5f8c90',
                                    primary: '#34585b',
                                    primary50: '#5f8c90'
                                },
                            })}
                        />
                    </div>
                    <SavedSearchFields
                        currentDataView={this.state.currentDataView}
                        lastSearch={this.props.lastSearch}
                        handleSelectedSearch={this.handleSelectedSearch}
                    />
                </div>
                <div style={{height: "calc(100% - 52px)"}}>
                    {this.state.currentBusinessObject && this.state.currentDataView ?
                        <ManageDataGrid
                            currentDataView={this.state.currentDataView}
                            currentBusinessObject={this.state.currentBusinessObject}
                            handleSelectedSearch={this.handleSelectedSearch}
                            onBusinessObjectChange={this.onBusinessObjectChange}
                        /> : null
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentDataView: state.boCore.currentDataView,
        businessObjectsWrapper: state.boCore.businessObjectsWrapper,
        dataViewsWrapper: state.boCore.dataViewsWrapper,
        title: state.topHeader.title,
        businessObject: state.manageDataBusinessObject.businessObject,
        selectedSearch: state.savedSearchReducer.selectedSearch,
        lastSearch: state.lastSearchReducer.lastSearch
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAllBusinessObjects: () => {
            dispatch(fetchAllBusinessObjects());
        },
        fetchAllDataViewsByBOCId: (bocId) => {
            dispatch(fetchAllDataViewsByBusinessObjectId(bocId));
        },
        fetchAllTags: () => {
            dispatch(fetchAllTags());
        },
        setCurrentDataView: (dataView) => {
            dispatch({
                type: actions.SET_CURRENT_DATA_VIEW,
                payload: dataView
            })
        },
        setTitle: (title) => {
            dispatch(setTitle(title))
        },
        setBusinessObject: (obj) => {
            dispatch(setBusinessObject(obj))
        },
        setSelectedSearch: (obj) => {
            dispatch(setSelectedSearch(obj))
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageData))



// WEBPACK FOOTER //
// ./app/views/bo-core/ManageData.tsx